"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const queNoIncluye = [{
  titulo: "Construcción de componentes nuevos",
  detalle: "Workflows nuevos, integraciones nuevas, módulos nuevos. Eso es Partner."
}, {
  titulo: "Cambios estructurales mayores",
  detalle: "Re-arquitecturas, migraciones grandes, replacement de plataformas core. Eso es Partner."
}, {
  titulo: "Proyectos de scope amplio",
  detalle: "Si entra una iniciativa que requiere planificación dedicada, sale del scope de Soporte."
}];
export default function NoIncluyeYCobranzaSoporte() {
  return <>
      <BloqueQueNoIncluye />
      <BloqueComoCobramos />
    </>;
}
function BloqueQueNoIncluye() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="soporte-que-no-incluye" id="que-no-incluye" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-12">
            Qué no incluye.
          </h2>

          <div className="space-y-10 mb-12">
            {queNoIncluye.map((item, i) => <div key={i}>
                <h3 className="font-serif text-2xl md:text-3xl text-foreground font-normal leading-tight mb-3">
                  {item.titulo}
                </h3>
                <p className="font-sans text-base md:text-lg text-muted-foreground leading-relaxed max-w-3xl">
                  {item.detalle}
                </p>
              </div>)}
          </div>

          <p className="font-sans text-base md:text-lg italic text-muted-foreground leading-relaxed max-w-2xl border-t border-border/30 pt-8">Si abres frente nuevo de construcción, regresamos a Partner. Tu negocio cambia. El servicio se acomoda.</p>
        </div>
      </div>
    </section>;
}
function BloqueComoCobramos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="soporte-cobranza" id="como-cobramos-soporte" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-10">
            Cómo cobramos.
          </h2>

          <div className="space-y-6 font-sans text-lg md:text-xl text-foreground/90 leading-relaxed max-w-2xl">
            <p>
              Iguala mensual fija acordada según volumen de infraestructura bajo soporte y SLA pactado.
            </p>

            <p className="text-muted-foreground italic">
              No por hora. No por ticket. La iguala cubre lo que está en scope; lo que sale de scope se mueve a Partner.
            </p>
          </div>
        </div>
      </div>
    </section>;
}